{
  "satis_urun_komisyon": {
    "Baslik": "Satış Ürün Komisyonları",
    "Unvan": "Ünvan",
    "Min Tutar": "Min Tutar",
    "Max Tutar": "Max Tutar",
    "Komisyon": "Komisyon",
    "Komisyon SM": "Komisyon SM",
    "Durum": "Status",
    "Ekle": "Ekle",
    "Duzenle": "Düzenle",
    "Sil": "Sil",
    "Kaydet": "Kaydet",
    "Guncelle": "Güncelle",
    "Vazgec": "Vazgeç",
    "Aktif": "Active",
    "Pasif": "Passive",
    "Islemler": "İşlemler",
    "Yenile": "Yenile",
    "Urun": "Ürün"
  }
}
